import React from 'react';
import { string, func } from 'prop-types';

import { Button } from '@snapask/common-components';
import Modal from '@blueberry/components/Modal';

import styles from './AlertModalHandler.scss';

function AlertModalHandler({ title, description, closeButtonText, onClose }) {
  return (
    <Modal>
      <div className={styles.root}>
        <div className={styles.inner}>
          <div className={styles.header}>
            <h5 className={styles.title}>{title}</h5>
          </div>
          <div className={styles.body}>{description}</div>
        </div>

        <div className={styles.footer}>
          <Button text={closeButtonText} onClick={onClose} theme={styles} />
        </div>
      </div>
    </Modal>
  );
}

AlertModalHandler.propTypes = {
  closeButtonText: string.isRequired,
  description: string.isRequired,
  title: string.isRequired,
  onClose: func.isRequired,
};

export default AlertModalHandler;



// WEBPACK FOOTER //
// ./app/containers/AlertModalHandler/AlertModalHandler.jsx